import { createSlice } from "@reduxjs/toolkit";
import {
  addRole,
  deleteRole,
  getActionByMenus,
  getMenus,
  getRoles,
  updateRole,
} from "./actions/roles.actions";

const initialState = {
  role: null,
  roles: null,
  total: 0,
  loading: false,
  menusLoading: false,
  actionsLoading: false,
  menus: null,
  menuActions: null,
  isEditing: false,
  filters: {},
  pageState: {
    page: 1,
    pageSize: 50,
  },
};

export const roleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    setRole: (state, action) => {
      const role = state.roles.find((_role) => _role.id === action.payload);
      state.role = role;
    },
    setIsEditing: (state, action) => {
      state.isEditing = action.payload;
    },
    setRoleFilters: (state, action) => {
      const { payload } = action;
      state.filters = payload;
    },
    resetRoleFilters: (state) => {
      state.filters = {};
    },
    setRolesPage: (state, action) => {
      const { page, pageSize } = action.payload;
      if (page) {
        state.pageState = { ...state.pageState, page };
      }
      if (pageSize) {
        state.pageState = { ...state.pageState, pageSize };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        const { data, count } = action.payload;
        state.loading = false;
        state.roles = data;
        state.total = count;
      })
      .addCase(getRoles.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(addRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(addRole.fulfilled, (state) => {
        state.loading = false;
        window.location.hash = "#/preferences/role";
      })
      .addCase(addRole.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(updateRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.loading = false;
        state.isEditing = false;
        state.role = action.payload;
      })
      .addCase(updateRole.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(deleteRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteRole.fulfilled, (state) => {
        state.loading = false;
        window.location.hash = "#/preferences/role";
      })
      .addCase(deleteRole.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getMenus.pending, (state) => {
        state.menusLoading = true;
      })
      .addCase(getMenus.fulfilled, (state, action) => {
        state.menusLoading = false;
        state.menus = action.payload;
      })
      .addCase(getMenus.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(getActionByMenus.pending, (state) => {
        state.actionsLoading = true;
      })
      .addCase(getActionByMenus.fulfilled, (state, action) => {
        state.actionsLoading = false;
        let list = {};
        action.payload.forEach((menu) => {
          let group = menu.name.split(".")[0];
          if (list[group]) {
            list[group].push(menu);
          } else {
            list[group] = [menu];
          }
        });
        state.menuActions = list;
      })
      .addCase(getActionByMenus.rejected, (state) => {
        state.actionsLoading = false;
      });
  },
});

export const {
  setRole,
  setIsEditing,
  setRoleFilters,
  resetRoleFilters,
  setRolesPage,
} = roleSlice.actions;

export default roleSlice.reducer;
